/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import classnames from 'classnames';
import ModeDeliveryTableFragment from './component/ModelDeliveryFragment';
import HpsParcelSectionWithData from './component/HpsParcelSectionWithData';

import {
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
} from 'reactstrap';

import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import { incoTermTable } from '../../common/data';
import metaMask from '../../assets/images/nft/notifalert.png';
import { isNumericOnly } from '../../utils/validators';
import axios from 'axios';
import { api } from '../../config';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { format } from 'date-fns';
import { convertToDisplayDateFormatddmmmyyyy } from '../../utils/dateformatter';
import logger from '../../utils/logger';
import {
  convertToInputDateFormat,
  convertToDisplayDateFormat,
  formatDateToDDMMYYYY,
  convertDisplayddMMyyyy,
  formatDateToddmmyyhhmm,
} from '../../utils/dateformatter';
import { formatNumber, formatNumberUS } from '../../utils/numberformatter';
import {
  PricingPeriodData,
  IncotermPortTypeData,
} from '../../constants/masterData';
import DeliveryVesselFirstLocation from './component/DeliveryVesselFirstLocation';
import DeliveryVesselFirstLocationNotes from './component/DeliveryVesselFirstLocationNotes.js';
import {
  BtnBold,
  BtnItalic,
  Editor,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  Separator,
} from 'react-simple-wysiwyg';
import IncotermTableFragment from './component/IncotermTableFragment';
import QuantityTableFragment from './component/QuantityTableFragment';
import { displayValue } from './utils/hpsHelpers';
import {
  downloadParcelExcel,
  downloadParcelExcelLpg,
} from './utils/parcelExportHelpers';
import UploadAlphaHpsModal from './component/UploadAlphaHpsModal';
import UploadNonLPGModal from './component/UploadNonLPGModal';
import '../../App.css';
import './HpsView.css';
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
const LPG_PRODUCT = ['4588b5e6-7309-49d0-9107-59cbb96b6bd8'];

const InfoField = ({ label, value, error }) => (
  <Col lg={4}>
    <div className='mb-2 field-border-brown'>
      <Label for='contractType' className='text-muted'>
        {label}
      </Label>
      <p className='mb-0 text-dark fw-medium'>{displayValue(value)}</p>
      {error && <div className='text-danger small mt-1'>{error}</div>}
    </div>
  </Col>
);

const openDocument = url => {
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};

const RequirementTab = ({
  ids,
  form,
  _setForm,
  dataCause,
  handleSaveDraftProc,
  validatedeliveryModal,
  errors,
  error,
  setError,
  setErrors,
  setIsLoading,
  isLoading,
  qtyDeliveryData,
  token,
}) => {
  const quantityRefs = useRef();

  // --- Nota Dinas: state lokal, belum dihubungkan ke API ---
  const [notaDinasForm, setNotaDinasForm] = useState({
    titleNotaDinas: '',
    noNotaDinas: '',
    hpsRequestDate: '',
  });
  const [fileAttachment, setFileAttachment] = useState(null);
  // Selalu null sampai alur simpan dibuat; disiapkan agar `disabled` tinggal hidup nanti.
  const [savingAction] = useState(null);
  const fileInputRef = useRef(null);
  const fieldRefs = {
    titleNotaDinas: useRef(null),
    noNotaDinas: useRef(null),
    hpsRequestDate: useRef(null),
    documentNotaDinas: fileInputRef,
  };

  const isHpsSubmitted = form?.statusHPS2 === true;
  const [isDownloadingParcel, setIsDownloadingParcel] = useState(false);
  const [isUploadAlphaHpsOpen, setIsUploadAlphaHpsOpen] = useState(false);
  const toggleUploadAlphaHps = () => setIsUploadAlphaHpsOpen(prev => !prev);
  const [alphaUploadVersion, setAlphaUploadVersion] = useState(0);

  const [isUploadNonLPGOpen, setIsUploadNonLPGOpen] = useState(false);
  const toggleUploadNonLPG = () => setIsUploadNonLPGOpen(prev => !prev);
  const [nonLPGUploadVersion, setNonLPGUploadVersion] = useState(0);

  // Isi ulang state lokal begitu data procurement termuat.
  useEffect(() => {
    if (!form?.id) return;
    setNotaDinasForm({
      titleNotaDinas: form.titleNotaDinas || '',
      noNotaDinas: form.noNotaDinas || '',
      hpsRequestDate: convertToInputDateFormat(form.hpsRequestDate) || '',
    });
  }, [form?.id, form?.titleNotaDinas, form?.noNotaDinas, form?.hpsRequestDate]);

  const handleFormChange = e => {
    const { name, value } = e.target;
    setNotaDinasForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const handleFileChange = e => {
    const file = e.target.files?.[0];
    if (file) {
      setFileAttachment(file);
      setErrors(prev => ({ ...prev, documentNotaDinas: undefined }));
    }
  };

  const handleDwnParcelLpg = async () => {
    if (!ids || !token) return;
    setIsDownloadingParcel(true);
    try {
      const res = await axios.get(
        `${api.API_URL}/procurement/get-delivery-parcel?PageNumber=1&PageSize=100&procurementId=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const parcels = res?.data || res?.data?.data || [];
      const ok = await downloadParcelExcelLpg(
        parcels,
        ids,
        form?.procurementNumber,
        token
      );
      if (!ok) {
        toast.warning('Tidak ada data parcel untuk diunduh');
      }
    } catch (err) {
      logger.error('Error downloading parcel:', err);
      toast.error('Gagal mengunduh data parcel');
    } finally {
      setIsDownloadingParcel(false);
    }
  };

  const handleDownloadParcel = async () => {
    if (!ids || !token) return;
    setIsDownloadingParcel(true);
    try {
      const res = await axios.get(
        `${api.API_URL}/procurement/get-delivery-parcel?PageNumber=1&PageSize=100&procurementId=${ids}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const parcels = res?.data || res?.data?.data || [];
      const ok = downloadParcelExcel(parcels, form?.procurementNumber);
      if (!ok) {
        toast.warning('Tidak ada data parcel untuk diunduh');
      }
    } catch (err) {
      logger.error('Error downloading parcel:', err);
      toast.error('Gagal mengunduh data parcel');
    } finally {
      setIsDownloadingParcel(false);
    }
  };

  const [isendDate, setIsEndDate] = useState(false);
  const [expandedClauses, setExpandedClauses] = useState({});
  const toggleClauseCard = id => {
    setExpandedClauses(prev => ({ ...prev, [id]: !prev[id] }));
  };
  const [unitSizeType, setUnitSizeType] = useState('');
  const [deletemodal, setDeleteModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [modalincoterm, setModalIncoterm] = useState(false);
  const [modalquantity, setModalQuantity] = useState(false);
  const [modalloadingdischarge, setModalLoadingDischarge] = useState(false);
  const [modalquantityincoterm, setModalQuantityIncoterm] = useState(false);
  const [productName, setProductName] = useState({ items: [] });
  const [productTypeData, setProductTypeData] = useState({ items: [] });
  const [currencyName, setCurrencyName] = useState({});
  const [ratioData, setRatioData] = useState({ items: [] });
  const [invoiceQuantityData, setInvoiceQuantityData] = useState({ items: [] });
  const [portRestrictionModal, setPortRestrictionModal] = useState(false);
  const [selectedPort, setSelectedPort] = useState(null);
  const [modelinvoiceQuantityData, setModelInvoiceQuantityData] = useState({
    items: [],
  });
  const [qtyDeliveryDataQuantity, setQtyDeliveryDataQuantity] = useState({
    items: [],
  });
  const [IncotermRouteData, setIncotermRouteData] = useState({ items: [] });
  const [IncotermLocationData, setIncoTermLocationData] = useState({
    items: [],
  });
  const [lawData, setLawData] = useState({ items: [] });
  const [abitrationData, setAbitrationData] = useState({ items: [] });
  const [dataindexprice, setDataIndexPrice] = useState({ items: [] });
  const [incotermtype, setIncotremType] = useState({ items: [] });
  const [qtyDeliveryDataIncoterm, setQtyDeliveryDataIncoterm] = useState({
    items: [],
  });
  const [butanesection, setButaneSection] = useState(false);
  const [propanesection, setPropaneSection] = useState(false);
  const [comptitle, setCompTile] = useState('');
  const [comptitlesec, setCompTileSec] = useState('');
  const [activeTab, setactiveTab] = useState('1');
  const toggles = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  const editorRef = useRef(null);

  const [activeTabs, setActiveTabs] = useState({});
  const toggle = (id, tab) => {
    setActiveTabs(prev => ({
      ...prev,
      [id]: tab,
    }));
  };

  const handleTextChangeDelivery = field => event => {
    setDeliveryFormData({
      ...deliveryformData,
      [field]: event.target.value,
    });
  };

  const handleDeliveryTextChange = e => {
    const { name, value } = e.target;
    setDeliveryFormData({ ...deliveryformData, [name]: value });
  };

  const handleDeliveryCheckBoxChange = e => {
    const { name, checked } = e.target;
    setDeliveryFormData({
      ...deliveryformData,
      [name]: checked ? 1 : 0,
    });
  };

  const handleDeliveryDateChange = e => {
    const { name, value } = e.target;
    setDeliveryFormData({
      ...deliveryformData,
      [name]: convertToDisplayDateFormat(value),
    });
  };

  const handleDeliverySelectChange = selectedOption => {
    setDeliveryFormData({
      ...deliveryformData,
      ratioLpgId: selectedOption.value,
    });
  };

  const validatequantityanddelivery = () => {
    let tempErrors = {};
    if (!deliveryformData.deliveryUnit?.trim()) {
      tempErrors.deliveryUnit = 'Please enter Delivery Unit';
    }

    if (!deliveryformData.frequency?.trim()) {
      tempErrors.frequency = 'Please enter Freq.';
    }

    if (form.productNameId === '4588b5e6-7309-49d0-9107-59cbb96b6bd8') {
      if (!deliveryformData.ratioLpgId) {
        tempErrors.ratioLpgId = 'Please Select Ratio';
      }
    }

    if (!deliveryformData.indexPriceId) {
      tempErrors.indexPriceId = 'Please Select ';
    }

    if (!deliveryformData.pricingPeriod) {
      tempErrors.pricingPeriod = 'Please Select ';
    }

    if (!deliveryformData.otherIndexPriceId) {
      tempErrors.otherIndexPriceId = 'Please Select ';
    }

    if (Object.keys(tempErrors).length !== 0) {
      toast.error('Warning ! Please Check Mandatory Fields..', {
        position: 'top-right',
        hideProgressBar: false,
        closeOnClick: false,
        className: 'bg-warning  text-black',
      });
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const toggledeletemodal = () => {
    setDeleteModal(!deletemodal);
  };

  const deliverymodal = () => {
    if (validatedeliveryModal()) {
      setModal(!modal);
    }
  };

  const togglemodalincoterm = () => {
    setModalIncoterm(!modalincoterm);
  };

  const quantitymodal = () => {
    setModalQuantity(!modalquantity);
  };

  const loadingdischrgemodal = () => {
    setModalLoadingDischarge(!modalloadingdischarge);
  };

  const togglemodalquantity = () => {
    setModalQuantity(!modalquantity);
  };

  const toggleloadingdischrge = () => {
    setModalLoadingDischarge(!modalloadingdischarge);
  };

  const handleAddDataDelivery = async () => {
    if (validatequantityanddelivery()) {
      try {
        setIsLoading(true);

        const response = await axios.post(
          `${api.API_URL}/quantity-delivery`,
          selectedFieldsDeliveryFormData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        fetchDeliveryDataDetail(response.id);
      } catch (error) {
        toast.error(`Failed to save data: ${error.message}`);
        setError(error.message);
      } finally {
        setIsLoading(false);
        handleSaveDraftProc(); // tetap jalan
        LoadDefault();
      }
    }
  };

  const handleUpdDataDelivery = async () => {
    try {
      setIsLoading(true);

      await axios.put(
        `${api.API_URL}/quantity-delivery/${deliveryformData.id}`,
        selectedFieldsDeliveryFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);

      fetchDeliveryDataDetail(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      handleSaveDraftProc();
      LoadDefault();
    }
  };

  useEffect(() => {
    quantityRefs.current = qtyDeliveryData.items.map(() => React.createRef());
  }, [qtyDeliveryData.items]);

  useEffect(() => {
    if (form.productTypeId) {
      CompositionVar(form.productTypeId);
    }
  }, [form.productTypeId]);

  const LoadDefault = async () => {
    try {
      await Promise.all([
        fetchProductName(),
        fetchInvoiceQuantity(),
        fetchIncotermRoute(),
        fetchIncotermLocation(),
        fetchIncotermType(),
      ]);
      setDeliveryFormData(prev => ({
        ...prev,
        procurementId: form.id,
      }));
    } catch (error) {
      logger.error('LoadDefault error:', error);
    }
  };

  const fetchProductName = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/product`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setProductName({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchInvoiceQuantity = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/invoicing-quantity`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setInvoiceQuantityData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchModeInvoiceQuantity = useCallback(
    async invoicingQuantityId => {
      try {
        const response = await fetch(
          `${api.API_URL}/invoicing-quantity/getAll-ModeInvoicingQuantity?InvoicingQuantityId=${invoicingQuantityId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          value: item.id,
          label: item.name,
        }));
        setModelInvoiceQuantityData({ items });
      } catch (error) {
        logger.error('Error:', error);
      }
    },
    [token]
  );

  const fetchProductType = useCallback(
    async productTypeId => {
      try {
        const response = await fetch(
          `${api.API_URL}/product/getAll-product-type?ProductId=${productTypeId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const result = await response.json();
        const items = result.data.items.map(item => ({
          value: item.id,
          label: item.name,
        }));
        setProductTypeData({ items });
      } catch (error) {
        logger.error('Error:', error);
      }
    },
    [token]
  );

  const handleSelectChangeDelivery = (e, field) => {
    setDeliveryFormData({
      ...deliveryformData,
      [field]: e ? e.value : '',
    });
  };

  const CompositionVar = action => {
    //let comptitle = "";
    switch (action) {
      case '4588b5e6-7309-49d0-9107-59cbb96b6b11':
        setCompTileSec('Refrigerated Propane');
        setPropaneSection(true);
        setButaneSection(false);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b12':
        setCompTile('Refrigerated Butane');
        setButaneSection(true);
        setPropaneSection(false);
        break;

      case '4588b5e6-7309-49d0-9107-59cbb96b6b13':
        setCompTile('LPG Mixed Pressurized');
        setButaneSection(true);
        setPropaneSection(false);
        break;

      case '4588b5e6-7309-49d0-9107-59cbb96b6b19':
        setCompTile('Pressurized Butane');
        setCompTileSec('Pressurized Propane');
        setButaneSection(true);
        setPropaneSection(true);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b18':
        setCompTile('Refrigrate Butane');
        setCompTileSec('Refrigrate Propane');
        setButaneSection(true);
        setPropaneSection(true);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b15':
        setCompTile('Pressurized Butane');
        setButaneSection(true);
        setPropaneSection(false);
        break;
      case '4588b5e6-7309-49d0-9107-59cbb96b6b14':
        setCompTileSec('Pressurized Propane');
        setPropaneSection(true);
        setButaneSection(false);
        break;
      //comptitle = "None";
    }
    //setCompTile(comptitle);
  };

  const [deliveryformData, setDeliveryFormData] = useState({
    procurementId: null,
    procurement: null,
    deliveryUnit: null,
    frequency: null,
    ratioLpgId: null,
    ratioLpg: null,
    pricingPeriod: null,
    indexPriceId: null,
    indexPrice: null,
    otherIndexPriceId: null,
    otherIndexPrice: null,
    isCorrelationBetweenTwoIndex: null,
    startDatePublishIndex: null,
    endDatePublishIndex: null,
    schemaBL: null,
    notesForPricing: null,
    id: null,
  });

  const fetchDeliveryDataDetail = async deliveryid => {
    try {
      const response = await axios.get(
        `${api.API_URL}/quantity-delivery/${deliveryid}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response;
      setDeliveryFormData({
        procurementId: data.procurementId || null,
        procurement: data.procurement || null,
        deliveryUnit: data.deliveryUnit || null,
        frequency: data.frequency || null,
        ratioLpgId: data.ratioLpgId || null,
        ratioLpg: data.ratioLpg || null,
        pricingPeriod: data.pricingPeriod || null,
        indexPriceId: data.indexPriceId || null,
        indexPrice: data.indexPrice || null,
        otherIndexPriceId: data.otherIndexPriceId || null,
        otherIndexPrice: data.otherIndexPrice || null,
        isCorrelationBetweenTwoIndex: data.isCorrelationBetweenTwoIndex || null,
        startDatePublishIndex:
          format(data.startDatePublishIndex, 'dd/MM/yyyy') || null,
        endDatePublishIndex:
          format(data.endDatePublishIndex, 'dd/MM/yyyy') || null,
        schemaBL: data.schemaBL || null,
        notesForPricing: data.notesForPricing || null,
        id: data.id || null,
      });
    } catch (error) {
      logger.error('Error fetching data from Invoice API:', error);
    }
  };

  const selectedFieldsDeliveryFormData = {
    procurementId: form.id,
    ratioLpgId: deliveryformData.ratioLpgId,
    deliveryUnit: deliveryformData.deliveryUnit,
    frequency: deliveryformData.frequency,
    pricingPeriod: deliveryformData?.pricingPeriod ?? 1,
    indexPriceId: deliveryformData.indexPriceId,
    otherIndexPriceId: deliveryformData.otherIndexPriceId,
    isCorrelationBetweenTwoIndex: deliveryformData.isCorrelationBetweenTwoIndex,
    startDatePublishIndex: deliveryformData?.startDatePublishIndex
      ? convertToInputDateFormat(deliveryformData.startDatePublishIndex)
      : null,
    endDatePublishIndex: convertToInputDateFormat(
      deliveryformData.endDatePublishIndex
    ),
    schemaBL: deliveryformData.schemaBL,
    notesForPricing: deliveryformData.notesForPricing,
  };

  const handleDeleteQtyDeliveryDetail = (id = null, _section = null) => {
    Swal.fire({
      title: `Are You sure want to Delete this Record?`,
      text: 'Deleted Data cannot be Recovered!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.isConfirmed) {
        // onDelete(); // Panggil props atau function untuk hapus data
        handleDelDataDeliveryQuantity(id);
        //Swal.fire("Deleted!", "Data was successfully deleted.", "success");
      }
    });
  };

  const handleDeleteIncotermDeliveryDetail = (
    id = null,
    _deliveryid = null,
    _section = null
  ) => {
    Swal.fire({
      title: `Are You sure want to Delete this Record?`,
      text: 'Deleted Data cannot be Recovered!!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.isConfirmed) {
        // onDelete(); // Panggil props atau function untuk hapus data
        handleDelDataDeliveryIncotermDetail(id);

        //Swal.fire("Deleted!", "Data was successfully deleted.", "success");
      }
    });
  };

  useEffect(() => {
    const newTabs = {};
    qtyDeliveryData.items.forEach(item => {
      newTabs[item.id] = `${item.id}1`;
    });
    setActiveTabs(newTabs);
  }, [qtyDeliveryData.items]);

  ///------- Quantity delivery

  const [deliveryquantityformData, setDeliveryQuantityFormData] = useState({
    quantityDeliveryTermId: null,
    quantity: null,
    quantityLocation1: null,
    quantityLocation2: null,
    id: null,
  });

  const handleDeliveryQuantityOpenModalNew = (_deliveryid = null) => {
    setDeliveryQuantityFormData({
      quantityDeliveryTermId: null,
      quantity: null,
      quantityLocation1: null,
      quantityLocation2: null,
      id: null,
    });
    quantitymodal();
  };

  const handleDeliveryQuantityOpenModalUpd = (deliveryqtyid = null) => {
    fetchDeliveryDataDetailSelectOneQuantity(deliveryqtyid);
    quantitymodal();
  };

  const handleLoadingDischargeOpenModalUpd = async (
    id = null,
    _deliveryid = null,
    _section = null
  ) => {
    await fetchDataDeliveryIncoterm(id);
    //fetchDeliveryDataDetailSelectOneQuantity(deliveryqtyid);
    loadingdischrgemodal();
  };

  const selectedFieldsDeliveryQuantityFormData = {
    quantityDeliveryTermId: deliveryformData.id,
    quantity: deliveryquantityformData.quantity,
  };

  const selectedFieldsDeliveryQuantityUpdData = {
    quantityDeliveryTermId: deliveryformData.id,
    quantity: deliveryquantityformData.quantity,
    quantityLocation1: deliveryquantityformData.quantityLocation1,
    quantityLocation2: deliveryquantityformData.quantityLocation2,
  };

  const fetchDeliveryDataDetailQuantity = async deliveryid => {
    try {
      const response = await fetch(
        `${api.API_URL}/quantity-information?QuantityDeliveryTermId=${deliveryid}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        quantityDeliveryTermId: item.quantityDeliveryTermId,
        quantity: item.quantity,
        quantityLocation1: item.quantityLocation1,
        quantityLocation2: item.quantityLocation2,
        id: item.id,
      }));
      setQtyDeliveryDataQuantity({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  const fetchDeliveryDataDetailSelectOneQuantity = async deliveryqtyid => {
    try {
      const response = await axios.get(
        `${api.API_URL}/quantity-information/${deliveryqtyid}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response;
      setDeliveryQuantityFormData({
        quantityDeliveryTermId: data.quantityDeliveryTermId,
        quantity: data.quantity,
        quantityLocation1: data.quantityLocation1,
        quantityLocation2: data.quantityLocation2,
        id: deliveryqtyid,
      });
    } catch (error) {
      logger.error('Error fetching data from Invoice API:', error);
    }
  };

  const handleUpdDataDeliveryQuantity = async deliveryqtyid => {
    try {
      setIsLoading(true);

      await axios.put(
        `${api.API_URL}/quantity-information/${deliveryqtyid}`,
        selectedFieldsDeliveryQuantityUpdData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
      fetchDeliveryDataDetailQuantity(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      LoadDefault();
    }
  };

  const handleAddDataDeliveryQuantity = async () => {
    try {
      setIsLoading(true);
      await axios.post(
        `${api.API_URL}/quantity-information`,
        selectedFieldsDeliveryQuantityFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Quantity Has been Added`);
      fetchDeliveryDataDetailQuantity(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      //handleSaveDraftProc(); // tetap jalan
      LoadDefault();
    }
  };

  const handleDelDataDeliveryQuantity = async id => {
    try {
      setIsLoading(true);
      await axios.delete(`${api.API_URL}/quantity-information/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Data has been deleted: ${deliveryformData.id}`);
      fetchDeliveryDataDetailQuantity(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to delete data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      LoadDefault();
    }
  };

  ///--- Add Incoterm---------------------------------------------------------------

  const handleSelectChangeIncoterm = (e, field) => {
    const value = e ? e.value : '';
    const newData = {
      ...deliveryincotermformData,
      [field]: value,
    };

    if (field === 'incotermId') {
      newData.timelineType =
        value === 'e0173dfd-e109-4054-8640-23d95befd326' ? 'ALD' : 'ADD';
      //fetchIncotermLocation(e.label, null);
      fetchIncotermLocation(null, e.value);
    }

    if (field === 'incotermRouteId') {
      fetchIncotermLocation(null, e.value);
    }

    setDeliveryIncotermFormData(newData);
  };

  const handleDeliveryDateChangeIncoterm = e => {
    const { name, value } = e.target;
    setDeliveryIncotermFormData({
      ...deliveryincotermformData,
      [name]: convertToDisplayDateFormat(value),
    });
  };

  const handleDeliveryNumberChangeIncoterm = fieldName => e => {
    const input = e.target.value;
    if (isNumericOnly(input)) {
      setDeliveryIncotermFormData({
        ...deliveryincotermformData,
        [fieldName]: input === '' ? null : parseInt(input),
      });
    }
  };

  const handleDeliveryTextChangeIncoterm = field => event => {
    setDeliveryIncotermFormData({
      ...deliveryincotermformData,
      [field]: event.target.value,
    });
  };

  const setDeliveryQuantityDefault = () => {
    setDeliveryQuantityFormData({
      quantityDeliveryTermId: null,
      quantity: null,
      quantityLocation1: null,
      quantityLocation2: null,
      id: null,
    });
  };

  const handleDeliveryQtyIncotermOpenModalUpd = (deliveryqtyid = null) => {
    setDeliveryQuantityDefault();
    setDeliveryQuantityFormData({
      quantityDeliveryTermId: null,
      quantity: null,
      quantityLocation1: null,
      quantityLocation2: null,
      id: null,
    });

    fetchDeliveryDataDetailSelectOneQuantity(deliveryqtyid);
    quantityincotermmodal();
  };

  const quantityincotermmodal = () => {
    setModalQuantityIncoterm(!modalquantityincoterm);
  };

  const togglemodalquantityincoterm = () => {
    setModalQuantityIncoterm(!modalquantityincoterm);
  };

  const fetchIncotermRoute = useCallback(async () => {
    try {
      const response = await fetch(
        `${api.API_URL}/incoterm/get-incoterm-route`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setIncotermRouteData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  }, [token]);

  const fetchIncotermLocation = async (_id = null, routeid = null) => {
    // const strquery =
    //   id === null ? `IncotermRouteId=${routeid}` : `Description=${id}`;

    //const producttype = form.productNameId === "4588b5e6-7309-49d0-9107-59cbb96b6bd8" ? true : null;
    const producttype =
      form.productNameId === '4588b5e6-7309-49d0-9107-59cbb96b6bd8' ??
      'IsLpgCase=true';

    try {
      const response = await fetch(
        `${api.API_URL}/incoterm/get-incoterm-location?IncotermRouteId=${routeid}&${producttype}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setIncoTermLocationData({ items });
    } catch (error) {
      logger.error('Error:', error);
    }
  };

  const [deliveryincotermformData, setDeliveryIncotermFormData] = useState({
    quantityDeliveryTermId: null,
    incotermId: null,
    incotermPortType: null,
    incotermRouteId: null,
    incotermLocationId: null,
    incotermLocation2Id: null,
    timelineType: null,
    startDate: null,
    endDate: null,
    timelineType2: null,
    startDate2: null,
    endDate2: null,
    alpha: null,
    loc1Draft1: null,
    loc1Draft2: null,
    loc1Loa1: null,
    loc1Loa2: null,
    loc1Dwt1: null,
    loc1Dwt2: null,
    loc1NotesForSTS: null,
    loc2Draft1: null,
    loc2Draft2: null,
    loc2Loa1: null,
    loc2Loa2: null,
    loc2Dwt1: null,
    loc2Dwt2: null,
    loc2NotesForSTS: null,
    additionalInformation: null,
    id: null,
  });

  const handleIncotermOpenModalNew = (_deliveryid = null) => {
    setDeliveryIncotermFormData({
      quantityDeliveryTermId: deliveryformData.id,
      incotermId: null,
      incotermPortType: null,
      incotermRouteId: null,
      incotermLocationId: null,
      incotermLocation2Id: null,
      timelineType: null,
      startDate: null,
      endDate: null,
      timelineType2: null,
      startDate2: null,
      endDate2: null,
      alpha: null,
      loc1Draft1: null,
      loc1Draft2: null,
      loc1Loa1: null,
      loc1Loa2: null,
      loc1Dwt1: null,
      loc1Dwt2: null,
      loc1NotesForSTS: null,
      loc2Draft1: null,
      loc2Draft2: null,
      loc2Loa1: null,
      loc2Loa2: null,
      loc2Dwt1: null,
      loc2Dwt2: null,
      loc2NotesForSTS: null,
      additionalInformation: null,
      id: null,
    });
    togglemodalincoterm();
  };

  const selectedFieldsDeliveryIncotermFormData = {
    quantityDeliveryTermId: deliveryformData.id,
    incotermId: deliveryincotermformData?.incotermId ?? null,
    incotermPortType: deliveryincotermformData?.incotermPortType ?? null,
    incotermRouteId: deliveryincotermformData?.incotermRouteId ?? null,
    incotermLocationId: deliveryincotermformData?.incotermLocationId ?? null,
    incotermLocation2Id: deliveryincotermformData?.incotermLocation2Id ?? null,
    timelineType: deliveryincotermformData?.timelineType ?? null,
    startDate:
      convertToInputDateFormat(deliveryincotermformData?.startDate) ?? null,
    endDate:
      convertToInputDateFormat(deliveryincotermformData?.endDate) ?? null,
    timelineType2: deliveryincotermformData?.timelineType2 ?? null,
    startDate2:
      convertToInputDateFormat(deliveryincotermformData?.startDate2) ?? null,
    endDate2:
      convertToInputDateFormat(deliveryincotermformData?.endDate2) ?? null,
    alpha: deliveryincotermformData?.alpha ?? null,
    loc1Draft1: deliveryincotermformData?.loc1Draft1 ?? null,
    loc1Draft2: deliveryincotermformData?.loc1Draft2 ?? null,
    loc1Loa1: deliveryincotermformData?.loc1Loa1 ?? null,
    loc1Loa2: deliveryincotermformData?.loc1Loa2 ?? null,
    loc1Dwt1: deliveryincotermformData?.loc1Dwt1 ?? null,
    loc1Dwt2: deliveryincotermformData?.loc1Dwt2 ?? null,
    loc1NotesForSTS: deliveryincotermformData?.loc1NotesForSTS ?? null,
    loc2Draft1: deliveryincotermformData?.loc2Draft1 ?? null,
    loc2Draft2: deliveryincotermformData?.loc2Draft2 ?? null,
    loc2Loa1: deliveryincotermformData?.loc2Loa1 ?? null,
    loc2Loa2: deliveryincotermformData?.loc2Loa2 ?? null,
    loc2Dwt1: deliveryincotermformData?.loc2Dwt1 ?? null,
    loc2Dwt2: deliveryincotermformData?.loc2Dwt2 ?? null,
    loc2NotesForSTS: deliveryincotermformData?.loc2NotesForSTS ?? null,
    additionalInformation:
      deliveryincotermformData?.additionalInformation ?? null,
  };

  const handleAddDataDeliveryIncoterm = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        `${api.API_URL}/quantity-incoterm`,
        selectedFieldsDeliveryIncotermFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //fetchDeliveryDataDetail(response.id);
      //toast.success(`Data has been Saved`);

      fetchDataDeliveryIncoterm(response.id);
      //quantityTableRef.current?.refresh(deliveryformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      handleSaveDraftProc(); // tetap jalan
      LoadDefault();
    }
  };

  const handleUpdDataDeliveryIncoterm = async () => {
    try {
      setIsLoading(true);

      await axios.put(
        `${api.API_URL}/quantity-incoterm/${deliveryincotermformData.id}`,
        selectedFieldsDeliveryIncotermFormData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);

      fetchDataDeliveryIncoterm(deliveryincotermformData.id);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      handleSaveDraftProc();
      LoadDefault();
    }
  };

  const fetchDataDeliveryIncoterm = async Id => {
    try {
      const response = await axios.get(
        `${api.API_URL}/quantity-incoterm/${Id}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      const data = response; // ✅ akses nested .data
      if (!data) {
        logger.warn('Data tidak ditemukan dari API');
        return null;
      }
      setDeliveryIncotermFormData({
        quantityDeliveryTermId: data.quantityDeliveryTermId || null,
        incotermId: data.incotermId || null,
        incotermPortType: data.incotermPortType || null,
        incotermRouteId: data.incotermRouteId || null,
        incotermLocationId: data.incotermLocationId || null,
        incotermLocationName: data.incotermLocation?.name || null,
        incotermLocation2Name: data.incotermLocation2?.name || null,
        incotermLocation2Id: data.incotermLocation2Id || null,
        timelineType: data.timelineType || null,
        startDate: convertDisplayddMMyyyy(data.startDate) || null,
        endDate: convertDisplayddMMyyyy(data.endDate) || null,
        timelineType2: data.timelineType2 || null,
        startDate2: convertDisplayddMMyyyy(data.startDate2) || null,
        endDate2: convertDisplayddMMyyyy(data.endDate2) || null,
        alpha: data.alpha || null,
        loc1Draft1: data.loc1Draft1 || null,
        loc1Draft2: data.loc1Draft2 || null,
        loc1Loa1: data.loc1Loa1 || null,
        loc1Loa2: data.loc1Loa2 || null,
        loc1Dwt1: data.loc1Dwt1 || null,
        loc1Dwt2: data.loc1Dwt2 || null,
        loc1NotesForSTS: data.loc1NotesForSTS || null,
        loc2Draft1: data.loc2Draft1 || null,
        loc2Draft2: data.loc2Draft2 || null,
        loc2Loa1: data.loc2Loa1 || null,
        loc2Loa2: data.loc2Loa2 || null,
        loc2Dwt1: data.loc2Dwt1 || null,
        loc2Dwt2: data.loc2Dwt2 || null,
        loc2NotesForSTS: data.loc2NotesForSTS || null,
        additionalInformation: data.additionalInformation || null,
        id: data.id || null,
      });

      return data;
    } catch (error) {
      logger.error('Error fetching data from Invoice API:', error);
      return null;
    }
  };

  const fetchIncotermType = useCallback(async () => {
    try {
      const response = await fetch(`${api.API_URL}/incoterm `, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      const items = result.data.items.map(item => ({
        value: item.id,
        label: item.name,
      }));
      setIncotremType({ items });
    } catch (error) {
      logger.error('Error index price:', error);
    }
  }, [token]);

  useEffect(() => {
    fetchProductName();
    fetchInvoiceQuantity();
    fetchIncotermRoute();
    fetchIncotermType();
    setDeliveryFormData(prev => ({
      ...prev,
      procurementId: form.id,
    }));
    setUnitSizeType(
      form.productNameId === '4588b5e6-7309-49d0-9107-59cbb96b6bd8'
        ? 'MT'
        : 'MB'
    );
    setIsEndDate(parseInt(form.contractType, 10) === 2);
  }, [
    form.id,
    form.productNameId,
    form.contractType,
    fetchProductName,
    fetchInvoiceQuantity,
    fetchIncotermRoute,
    fetchIncotermType,
  ]);

  useEffect(() => {
    if (form.invoicingQuantityId) {
      fetchModeInvoiceQuantity(form.invoicingQuantityId);
    }
  }, [form.invoicingQuantityId, fetchModeInvoiceQuantity]);

  useEffect(() => {
    if (form.productNameId) {
      fetchProductType(form.productNameId);
    }
  }, [form.productNameId, fetchProductType]);

  const handleDelDataDeliveryIncotermDetail = async id => {
    try {
      setIsLoading(true);
      await axios.delete(`${api.API_URL}/quantity-incoterm/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(`Data has been deleted`);
    } catch (error) {
      toast.error(`Failed to delete data: ${error.message}`);
      setError(error.message);
    } finally {
      setIsLoading(false);
      LoadDefault();
    }
  };

  const handleIncotermOpenModal = async (
    Id = null,
    _IncotermId = null,
    _Section = null
  ) => {
    const data = await fetchDataDeliveryIncoterm(Id);
    if (data && data.incotermId) {
      fetchIncotermLocation(null, data.incotermId);
    }
    togglemodalincoterm();
  };

  const handleConfirmProcess = () => {
    Swal.fire({
      title: 'Are You Sure?',
      text: 'Data will be processed',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Process',
      cancelButtonText: 'Cancel',
    }).then(result => {
      if (result.isConfirmed) {
        handleSaveReleasedHps(ids);
      } else {
        console.log('User membatalkan');
      }
    });
  };

  const handleSaveReleasedHps = async ids => {
    try {
      const response = await axios.post(
        `${api.API_URL}/hps/update-status-availability`,
        null,
        {
          params: { procurementId: ids },
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // jika ada token
          },
        }
      );
      console.log('Response:', response.data);
    } catch (error) {
      console.error('Error submit procurement:', error.message);
    }
  };

  //----

  return (
    <React.Fragment>
      <Row>
        <div>
          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>
                        <i className='ri-file-list-3-line me-2'></i>
                        Procurement Information
                      </h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Procurement Type :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {form?.procurementTypeHeaderLabel}
                    </p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Title Procurement :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {form?.titleProcurement}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  {!isendDate && (
                    <div className='mb-2 field-border-brown'>
                      <Label for='contractPeriodTermEnd' className='text-muted'>
                        {' '}
                        Proc Type{' :'}
                      </Label>

                      <p className='form-label mb-3 fs-12 '>
                        {form.procurementType}
                      </p>
                    </div>
                  )}
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Contract Type :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {parseInt(form?.contractType ?? 0, 10) === 1
                        ? 'TERM'
                        : 'SPOT'}
                    </p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractPeriodTermStart' className='text-muted'>
                      {!isendDate ? 'Start Period :' : 'Period :'}{' '}
                    </Label>
                    <p className='form-label mb-3 fs-12 '>
                      {form.contractPeriodTermStart
                        ? format(
                            new Date(form.contractPeriodTermStart),
                            'MMMM yyyy'
                          )
                        : '-'}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  {!isendDate && (
                    <div className='mb-2 field-border-brown'>
                      <Label for='contractPeriodTermEnd' className='text-muted'>
                        {' '}
                        End Period{' :'}
                      </Label>

                      <p className='form-label mb-3 fs-12 '>
                        {form.contractPeriodTermEnd
                          ? format(
                              new Date(form.contractPeriodTermEnd),
                              'MMMM yyyy'
                            )
                          : '-'}
                      </p>
                    </div>
                  )}
                </Col>
              </Row>

              <Row>
                <Col sm={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label className='text-muted'>Product Name :</Label>
                    <p className='form-label mb-2 fs-13 '>
                      {productName.items?.find(
                        obj => obj.value === form.productNameId
                      )?.label || '-'}
                    </p>
                  </div>
                </Col>

                <Col sm={4}>
                  <div className='mb-2 field-border-brown'>
                    <p className='form-label '>Product Type </p>

                    <p className='text-muted mb-2 fs-12 '>
                      {productTypeData.items?.find(
                        obj => obj.value === form.productTypeId
                      )?.label || '-'}
                    </p>
                  </div>
                </Col>

                <Col sm={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractPeriodTermStart' className='form-label'>
                      Operational Tolerance{' '}
                    </Label>

                    <p className='form-label mb-2 fs-12 '>
                      {form.operationalTolerance || ''}
                      {' %'}
                    </p>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Request HPS</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      HPS Request Numbers :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {form?.procurementTypeHeaderLabel}
                    </p>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className='mb-2 field-border-brown'>
                    <Label for='contractType' className='text-muted'>
                      Request Date :
                    </Label>
                    <p className='form-label mb-2 fs-13 '>
                      {form?.titleProcurement}
                    </p>
                  </div>
                </Col>
              </Row>

              <Row className='g-3'>
                {isHpsSubmitted ? (
                  <>
                    <InfoField
                      label='Title Nota Dinas'
                      value={form.titleNotaDinas}
                      error={errors.titleNotaDinas}
                    />
                    <InfoField
                      label='No. Nota Dinas'
                      value={form.noNotaDinas}
                      error={errors.noNotaDinas}
                    />
                    <InfoField
                      label='Date Nota Dinas'
                      value={
                        form.hpsRequestDate
                          ? formatDateToDDMMYYYY(form.hpsRequestDate)
                          : '-'
                      }
                      error={errors.hpsRequestDate}
                    />
                    <Col md={12} lg={12}>
                      <div className='mb-3'>
                        <Label className='fw-semibold small text-dark mb-2'>
                          Document Nota Dinas
                        </Label>

                        <div className='border rounded-3 p-2 d-flex align-items-center justify-content-between bg-light'>
                          <div className='d-flex align-items-center overflow-hidden me-2'>
                            <div
                              className='d-flex align-items-center justify-content-center rounded bg-primary-subtle p-2 me-2 text-primary'
                              style={{
                                width: '36px',
                                height: '36px',
                                flexShrink: 0,
                              }}
                            >
                              <i className='ri-file-text-line fs-18'></i>
                            </div>

                            <span className='small text-dark fw-medium'>
                              {(() => {
                                const rawName =
                                  form?.documentNotaDinasName ||
                                  form?.documentNotaDinas;
                                if (!rawName) return 'Nota Dinas Document';
                                return rawName.includes('_')
                                  ? rawName.substring(rawName.indexOf('_') + 1)
                                  : rawName;
                              })()}
                            </span>
                          </div>

                          {form?.documentNotaDinasUrl && (
                            <Button
                              color='primary'
                              size='sm'
                              outline
                              className='d-flex align-items-center gap-1 btn-sm shadow-none'
                              onClick={() =>
                                openDocument(form.documentNotaDinasUrl)
                              }
                            >
                              <i className='ri-eye-line fs-14'></i>
                              <span>View</span>
                            </Button>
                          )}
                        </div>
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                    <Alert
                      color='warning'
                      className='d-flex align-items-start gap-2'
                    >
                      <i className='bx bx-error flex-shrink-0 mt-1'></i>
                      <span className='small'>
                        Please submit the HPS Market request through P-Office
                        first before you can provide the information below
                      </span>
                    </Alert>
                    <Col md={6} lg={4}>
                      <FormGroup>
                        <Label className='fw-semibold small text-dark'>
                          Title Nota Dinas
                        </Label>
                        <Input
                          innerRef={fieldRefs.titleNotaDinas}
                          name='titleNotaDinas'
                          type='text'
                          placeholder='Input title nota dinas'
                          className='bg-white'
                          value={notaDinasForm.titleNotaDinas}
                          onChange={handleFormChange}
                          invalid={!!errors.titleNotaDinas}
                        />
                        {errors.titleNotaDinas && (
                          <div className='text-danger small mt-1'>
                            {errors.titleNotaDinas}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md={6} lg={4}>
                      <FormGroup>
                        <Label className='fw-semibold small text-dark'>
                          No. Nota Dinas
                        </Label>
                        <Input
                          innerRef={fieldRefs.noNotaDinas}
                          name='noNotaDinas'
                          type='text'
                          placeholder='Input no. nota dinas'
                          className='bg-white'
                          value={notaDinasForm.noNotaDinas}
                          onChange={handleFormChange}
                          invalid={!!errors.noNotaDinas}
                        />
                        {errors.noNotaDinas && (
                          <div className='text-danger small mt-1'>
                            {errors.noNotaDinas}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md={6} lg={4}>
                      <FormGroup>
                        <Label className='fw-semibold small text-dark'>
                          Date Nota Dinas
                        </Label>
                        <Input
                          innerRef={fieldRefs.hpsRequestDate}
                          name='hpsRequestDate'
                          type='date'
                          className='bg-white'
                          value={notaDinasForm.hpsRequestDate}
                          onChange={handleFormChange}
                          invalid={!!errors.hpsRequestDate}
                        />
                        {errors.hpsRequestDate && (
                          <div className='text-danger small mt-1'>
                            {errors.hpsRequestDate}
                          </div>
                        )}
                      </FormGroup>
                    </Col>

                    <Col md={12} lg={12}>
                      <FormGroup>
                        <Label className='fw-semibold small text-dark mb-2'>
                          Document Nota Dinas
                        </Label>

                        <input
                          type='file'
                          id='fileAttachment'
                          name='fileAttachment'
                          onChange={handleFileChange}
                          disabled={!!savingAction}
                          ref={fileInputRef}
                          style={{ display: 'none' }}
                        />

                        {fileAttachment ? (
                          <div className='border rounded-3 p-2 d-flex align-items-center justify-content-between bg-light border-dashed'>
                            <div className='d-flex align-items-center overflow-hidden me-2'>
                              <div
                                className='d-flex align-items-center justify-content-center rounded bg-primary-subtle p-2 me-2 text-primary'
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  flexShrink: 0,
                                }}
                              >
                                <i className='ri-file-text-line fs-18'></i>
                              </div>
                              <span className='small text-dark text-truncate fw-medium'>
                                {fileAttachment.name}
                              </span>
                            </div>
                            <Button
                              color='light'
                              size='sm'
                              className='border shadow-none bg-white text-danger d-flex align-items-center justify-content-center'
                              style={{
                                width: '30px',
                                height: '30px',
                                padding: 0,
                              }}
                              disabled={!!savingAction}
                              onClick={() => {
                                setFileAttachment(null);
                                if (fileInputRef.current) {
                                  fileInputRef.current.value = '';
                                }
                              }}
                              title='Remove file'
                            >
                              <i className='ri-delete-bin-line fs-14'></i>
                            </Button>
                          </div>
                        ) : form?.documentNotaDinasName ||
                          form?.documentNotaDinas ||
                          form?.documentNotaDinasUrl ? (
                          <div className='border rounded-3 p-2 d-flex align-items-center justify-content-between bg-light'>
                            <div className='d-flex align-items-center overflow-hidden me-2'>
                              <div
                                className='d-flex align-items-center justify-content-center rounded bg-primary-subtle p-2 me-2 text-primary'
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  flexShrink: 0,
                                }}
                              >
                                <i className='ri-file-text-line fs-18'></i>
                              </div>
                              <span className='small text-dark text-truncate fw-medium'>
                                {(() => {
                                  const rawName =
                                    form?.documentNotaDinasName ||
                                    form?.documentNotaDinas;
                                  if (!rawName) return 'Nota Dinas Document';
                                  return rawName.includes('_')
                                    ? rawName.substring(
                                        rawName.indexOf('_') + 1
                                      )
                                    : rawName;
                                })()}
                              </span>
                            </div>
                            <div className='d-flex align-items-center gap-1 flex-shrink-0'>
                              {form?.documentNotaDinasUrl && (
                                <Button
                                  color='primary'
                                  size='sm'
                                  outline
                                  className='d-flex align-items-center gap-1 btn-sm shadow-none py-2 px-4'
                                  onClick={() =>
                                    openDocument(form.documentNotaDinasUrl)
                                  }
                                >
                                  <i className='ri-eye-line fs-14'></i>
                                  <span>View</span>
                                </Button>
                              )}
                              <Button
                                color='danger'
                                size='sm'
                                outline
                                className='d-flex align-items-center gap-1 btn-sm shadow-none py-2 px-4'
                                disabled={!!savingAction}
                                onClick={() =>
                                  !savingAction && fileInputRef.current?.click()
                                }
                              >
                                <i className='ri-upload-2-line fs-14'></i>
                                <span>Replace</span>
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={`border rounded-3 p-3 d-flex align-items-center bg-white ${
                              errors.documentNotaDinas ? 'border-danger' : ''
                            }`}
                            style={{
                              cursor: savingAction ? 'not-allowed' : 'pointer',
                              opacity: savingAction ? 0.6 : 1,
                            }}
                            onClick={() =>
                              !savingAction && fileInputRef.current?.click()
                            }
                          >
                            <div
                              className='d-flex align-items-center justify-content-center rounded-circle me-3'
                              style={{
                                width: '48px',
                                height: '48px',
                                backgroundColor: errors.documentNotaDinas
                                  ? '#fdf2f2'
                                  : '#f3f6fa',
                                flexShrink: 0,
                              }}
                            >
                              <i
                                className={`ri-upload-2-line fs-20 ${errors.documentNotaDinas ? 'text-danger' : 'text-secondary'}`}
                              ></i>
                            </div>
                            <div>
                              <h5 className='fs-14 fw-semibold text-dark mb-0'>
                                Upload File
                              </h5>
                              <span className='text-muted small fs-12'>
                                Browse from your device
                              </span>
                            </div>
                          </div>
                        )}

                        {errors.documentNotaDinas && (
                          <div className='text-danger small mt-2 fs-12 fw-medium d-flex align-items-center gap-1'>
                            <i className='ri-error-warning-line align-middle'></i>
                            {errors.documentNotaDinas}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </>
                )}
              </Row>
            </CardBody>
          </Card>

          <Card className='border shadow-sm'>
            <CardBody>
              <Row>
                {form.statusHPS2 === false && (
                  <Col lg={12}>
                    <Alert
                      color='info'
                      className='d-flex align-items-start gap-2 mt-2'
                    >
                      <i className='bx  bx-error flex-shrink-0 mt-1'></i>
                      <span className='small'>
                        The detailed procurement plan information below can be
                        downloaded in Excel format to be used as an attachment
                        in the submission of the HPS Alpha Request Memorandum.
                      </span>
                    </Alert>
                  </Col>
                )}
                <Col sm={12}>
                  <div
                    color='dark'
                    className='d-flex align-items-center mb-2  '
                  >
                    <div className='flex-grow-1'>
                      <h5 className='mb-1'>Parcel</h5>
                      <p className='text-muted mb-2 fs-12 '>
                        Bisa jadi Kalimat tambahan untuk membantu section
                        mengenai apa ini
                      </p>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                      <Button
                        color='success'
                        size='sm'
                        className='d-flex align-items-center gap-1'
                        onClick={
                          !LPG_PRODUCT.includes(form.productNameId)
                            ? handleDownloadParcel
                            : handleDwnParcelLpg
                        }
                        disabled={isDownloadingParcel}
                      >
                        {isDownloadingParcel ? (
                          <>
                            <span className='spinner-border spinner-border-sm' />{' '}
                            Downloading...
                          </>
                        ) : (
                          <>
                            <i className='bx bx-download' /> Download Parcel
                          </>
                        )}
                      </Button>

                      <Button
                        color='primary'
                        size='sm'
                        className='d-flex align-items-center gap-1'
                        onClick={
                          !LPG_PRODUCT.includes(form.productNameId)
                            ? toggleUploadNonLPG
                            : toggleUploadAlphaHps
                        }
                      >
                        <i className='bx bxs-file-import'></i> Upload Parcel
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xl={12}>
                  <div className='mb-1 '>
                    {/* <CardBody> */}
                    {isLoading ? (
                      <Col lg={12} className='text-center'>
                        <div className='text-center'>
                          <div
                            className='spinner-border text-primary'
                            role='status'
                          >
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                        </div>
                      </Col>
                    ) : error ? (
                      <Col lg={12} className='text-center'>
                        <div className='text-center'>
                          <div className='alert alert-danger'>{error}</div>
                        </div>
                      </Col>
                    ) : (
                      <>
                        {qtyDeliveryData.items.length > 0 ? (
                          qtyDeliveryData.items.map((data, index) => (
                            <Col sm={12} key={`${data.id}-${index}`}>
                              <Col xxl={12}>
                                <TabPane tabId={`${data.id}2`} id='product'>
                                  <Col sm={12}>
                                    <div
                                      className=' mb-2 mt-3'
                                      style={{
                                        borderTopColor: '#b0b8b2',
                                        borderTopWidth: '1px',
                                        borderTopStyle: 'solid',
                                      }}
                                    ></div>

                                    <Row>
                                      <Col sm={5}>
                                        <Row>
                                          <Col sm={6}>
                                            <div className=' mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Delivery Unit :
                                              </Label>
                                              <p className='form-label fw-semibold fs-12 '>
                                                {data.deliveryUnit || ''}
                                              </p>
                                            </div>
                                          </Col>

                                          <Col sm={6}>
                                            <div className=' mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Pricing Periods :
                                              </Label>
                                              <p className='form-label fw-semibold fs-12 '>
                                                {PricingPeriodData[0].options.find(
                                                  option =>
                                                    option.value ===
                                                    data.pricingPeriod
                                                )?.label || '-'}
                                              </p>
                                            </div>
                                          </Col>

                                          <Col sm={6}>
                                            <div className=' mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Index Price Reference :
                                              </Label>
                                              <p className='form-label fw-semibold fs-12 '>
                                                {data.indexPricename || ''}
                                              </p>
                                            </div>
                                          </Col>

                                          <Col sm={6}>
                                            <div className=' mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Other Index Price :
                                              </Label>
                                              <p className='form-label fw-semibold fs-12 '>
                                                {data.otherIndexPricename || ''}
                                              </p>
                                            </div>
                                          </Col>

                                          <Col sm={12}>
                                            <div className='mb-2 mt-2'>
                                              <Label
                                                className='form-check-label'
                                                for='inlineCheckbox8'
                                              >
                                                Correlation between two index
                                                whicever to lower
                                              </Label>
                                            </div>
                                          </Col>

                                          <Col sm={4}>
                                            <div className='mb-2 mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Publish Index Period :
                                              </Label>
                                              <p className='form-label mb-2 fs-12 '>
                                                {formatDateToDDMMYYYY(
                                                  data.startDatePublishIndex
                                                ) || ''}
                                              </p>
                                            </div>
                                          </Col>

                                          <Col sm={4}>
                                            <div className='mb-2 mt-2  '>
                                              <Label className='text-muted'>
                                                {''}
                                              </Label>
                                              <p className='form-label mb-2 fs-12 '>
                                                {formatDateToDDMMYYYY(
                                                  data.endDatePublishIndex
                                                ) || ''}
                                              </p>
                                            </div>
                                          </Col>

                                          <Col sm={4}>
                                            <div className='mb-2 mt-2  field-border-brown'>
                                              <Label className='text-muted'>
                                                Schema B/L Date :
                                              </Label>
                                              <p className='form-label mb-2 fs-12 '>
                                                {data.schemaBL || '-'}
                                              </p>
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>

                                      <Col sm={7}>
                                        <Label
                                          for='product-name-3'
                                          className='form-label '
                                        >
                                          Notes for Pricing
                                        </Label>
                                        <div className='snow-editor '>
                                          <EditorProvider>
                                            <Editor
                                              id='notesForPricingRO'
                                              name='notesForPricingRO'
                                              value={data.notesForPricing || ''}
                                              readOnly
                                              style={{
                                                height: '200px',
                                                overflowY: 'auto',
                                              }}
                                            ></Editor>
                                          </EditorProvider>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                  {!LPG_PRODUCT.includes(form.productNameId) ? (
                                    <ModeDeliveryTableFragment
                                      procurementId={ids}
                                      quantityDeliveryTermId={data.id}
                                      token={token}
                                    />
                                  ) : (
                                    <HpsParcelSectionWithData
                                      parcels={[data]}
                                      procurement={form}
                                      token={token}
                                      isReadOnly
                                      alphaUploadVersion={alphaUploadVersion}
                                    />
                                  )}
                                </TabPane>
                              </Col>
                            </Col>
                          ))
                        ) : (
                          <Col lg={12} className='text-center'>
                            <h5 className='fs-15'>
                              <i className='ri-database-2-line me-2'></i>
                              No data available
                            </h5>
                          </Col>
                        )}
                      </>
                    )}
                    {/* </CardBody> */}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <UploadAlphaHpsModal
            isOpen={isUploadAlphaHpsOpen}
            toggle={toggleUploadAlphaHps}
            procurementId={ids}
            token={token}
            onUploaded={() => setAlphaUploadVersion(v => v + 1)}
          />

          <UploadNonLPGModal
            isOpen={isUploadNonLPGOpen}
            toggle={toggleUploadNonLPG}
            token={token}
            onUploaded={() => setNonLPGUploadVersion(v => v + 1)}
          />

          {form.statusHPS2 === false && (
            <div className='req-actionbar'>
              <button
                type='button'
                className='btn btn-primary btn-label right ms-auto nexttab'
                onClick={handleConfirmProcess}
              >
                <i className='ri-login-box-line  label-icon align-middle fs-16 ms-2'></i>
                Submit HPS Request
              </button>
            </div>
          )}
        </div>
      </Row>
    </React.Fragment>
  );
};

export default RequirementTab;
